module.exports = __webpack_public_path__ + "static/assets/c9fea52b160ea2372cbbb9b768bc5af7.png";